import * as React from 'react';
import {useTheme} from '@mui/material/styles';
import Box from '@mui/material/Box';
import MobileStepper from '@mui/material/MobileStepper';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import SwipeableViews from 'react-swipeable-views';
import {autoPlay} from 'react-swipeable-views-utils';
import {TiChevronLeftOutline, TiChevronRightOutline} from "react-icons/ti";
import Employee from "./Employee";
//import Olesia3 from "./photos/Olesia3.jpg";
import classes from "./Employees.module.scss"
 

const AutoPlaySwipeableViews = autoPlay(SwipeableViews);

function SwipeableTextMobileStepper() {

    const employees = [
        /*{
            fullName: 'Вдовенко Леся Олександрівна',
            position: 'Головний бухгалтер підприємства. Безперебійний та надійний супровід документообігу.',
            phone: '+380960968402',
            img: Olesia3
        },*/
    ];

    const theme = useTheme();
    const [activeStep, setActiveStep] = React.useState(0);
    const maxSteps = employees.length;
    
    const handleNext = () => {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
    };

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    const handleStepChange = (step) => {
        setActiveStep(step);
    };

    if (employees.length === 0) return null;

    return (
        <Box xs={6} sm={4} md={3}>
            <Paper
                square
                elevation={0}
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    height: 50,
                    pl: 2,
                    bgcolor: 'background.default',
                }}
            >
            </Paper>
            <AutoPlaySwipeableViews
                axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
                index={activeStep}
                onChangeIndex={handleStepChange}
                enableMouseEvents
            >

                {employees.map(employee => (
                    <Employee user={employee}/>
                ))}

            </AutoPlaySwipeableViews>
                       <Paper
                square
                elevation={0}
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    height: 50,
                    pl: 2,
                    bgcolor: 'background.default',
                }}
            >
            </Paper>
        </Box>
    );
}

export default SwipeableTextMobileStepper;

